import {selectByUser,loginOut} from "@/api/home";
const namespaced=true;

const state={
    userName:''
}
const mutations={
    userName(state,username){
        state.userName=username
    }
}
const actions={
    // 获取用户信息
    async selectByUser({ commit }, params) {
        const res = await selectByUser()
        commit('userName',res.data.username)
    },
    // 注销
    async loginOut({ commit }, params) {
        const res = await loginOut()
        let {code}=res
        if(code==200){
            window.localStorage.removeItem('Authorization')
            setInterval(()=>{
                window.location.reload()
            },100)
        }
    },
}

const getters={

}
export default {
    mutations,
    actions,
    state,
    namespaced,
    getters
}
